import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellServiceItemSerial } from 'ui/Element/List/Item/Cell/ServiceItem/Serial'

export default CellHOC(
  LabeledHOC(
    props => props.labels.serial,
    ListItemCellServiceItemSerial,
  ),
)
